import api from "./apiConfig.js";

export const SEND_EMAIL = async (data) => {
	try {
		const response = await api.post("/sendMeetingEmail", data);
		return response.data;
	} catch (error) {
			console.error(error);
	}
};
